import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { X } from 'lucide-react'
import { useAchievementsStore } from '@/store/achievements'
import { useAppStore } from '@/store/app'
import { AchievementIcon } from './AchievementIcon'
import styles from './AchievementToast.module.css'

/** Сколько карточка висит сама по себе. */
const SHOW_MS = 9000

/**
 * Карточка «Достижение получено» внизу экрана: что получено и что это дало. Несколько подряд
 * (после сверки их может прийти пачка) показываются по одной.
 */
export function AchievementToast() {
  const current = useAchievementsStore((s) => s.queue[0])
  const dismiss = useAchievementsStore((s) => s.dismiss)
  const setView = useAppStore((s) => s.setView)
  const closeSettings = useAppStore((s) => s.closeSettings)
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!current) return
    // награды уже выданы: списки украшений и достижений устарели
    void queryClient.invalidateQueries({ queryKey: ['decorations'] })
    void queryClient.invalidateQueries({ queryKey: ['achievements'] })
    const timer = setTimeout(dismiss, SHOW_MS)
    return () => clearTimeout(timer)
  }, [current, dismiss, queryClient])

  if (!current) return null
  const decorative = current.rewards.length > 0
  return (
    <div className={styles.toast} role="status" aria-live="polite">
      <AchievementIcon id={current.id} size={44} />
      <div className={styles.text}>
        <span className={styles.title}>Достижение «{current.name}»</span>
        <span className={styles.sub}>{decorative ? `${current.rewards.map((r) => r.name).join(', ')} — можно надеть в магазине` : 'Получено'}</span>
      </div>
      <button
        type="button"
        className={styles.action}
        onClick={() => {
          closeSettings()
          setView({ kind: 'home', page: decorative ? 'shop' : 'achievements' })
          dismiss()
        }}
      >
        {decorative ? 'Надеть' : 'Открыть'}
      </button>
      <button type="button" className={styles.close} aria-label="Закрыть" onClick={dismiss}><X size={16} /></button>
    </div>
  )
}
